import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import operationService from '../../../services/operationService';
import Context from './context';
import { NumberRoute } from '../../../types';
import { Operation } from '../../../services/types/Operation';
import { globalServiceScope } from '../../../services/serviceBase';
import MainContext from '../../App/MainProvider/context';

const OperationProviderNew: React.FC<NumberRoute> = ({ number, children }) => {
  // const [operation, loading, , , , reload] = useServiceReducer(
  //   (i: string) => {
  //     const promise = operationService.getByNumber(i);
  //     promise.then(o => {
  //       if (o) {
  //         globalServiceScope.operationNumber = o ? o.number : '';
  //       }
  //     });
  //     return promise;
  //   },
  //   operReducer,
  //   number
  // );

  const { service, notify } = useContext(MainContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loading, setLoading] = React.useState(false);
  const [operation, setOperation] = React.useState<Operation | null>(null);

  const operationNotFound = () => {
    notify(t('error'), t('operationNotFound'), 'danger');
    setTimeout(() => {
      navigate('/');
    }, 200);
  };

  const loadData = useCallback(
    () =>
      service(() => operationService.getByNumber(number), {
        loader: setLoading,
        callback: (op) => {
          globalServiceScope.operationNumber = op ? op.number : '';

          if (op) {
            setOperation(op);
          } else {
            operationNotFound();
          }
        },
        onError: (error: AxiosError | Error) => {
          if ('isAxiosError' in error && error.response && error.response.status === 404) {
            operationNotFound();
          }

          return false;
        },
      }),
    [number, service]
  );

  const reload = useCallback(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (number) {
      loadData();
    }
  }, [number]);

  useEffect(
    () => () => {
      globalServiceScope.operationNumber = '';
    },
    []
  );
  const value = useMemo(
    () => operation && { operation, loading, reload },
    [operation, loading, reload]
  );

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default OperationProviderNew;
